import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';
import { UpdatePersonRequest } from '@planbord/shared/models';

export const useUpdatePerson = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: {
      Id: number;
      UpdatePersonRequest: UpdatePersonRequest;
    }) =>
      axiosRequest
        .put(`${baseUrl}/updatePerson/${value.Id}`, value.UpdatePersonRequest)
        .then((res) => {
          return res.data;
        }),
  });
};
